class Button {
  constructor(el) {
    this.el = el;
    this.mount();
  }

  mount() {
    this.bindSettings();
    this.bindEvents();
  }

  bindSettings() {
    this.htmlToggle = this.el.getAttribute('data-html-toggle');
  }

  bindEvents() {
    // js enhancement for "return" key on menu toggle
    this.el.addEventListener('keyup', this.onKeyUp.bind(this));

    // adding classes to html when checked / unchecked
    if (this.htmlToggle) {
      this.el.addEventListener('click', this.onClick.bind(this));
    }

    // firing on touchstart to get around double-clicking
    // on iOS because of :hover, :focus styles.
    // Don't even need to do any work within the event.
    if (this.el.nextElementSibling) {
      this.el.nextElementSibling.addEventListener('touchstart', function() { }, {passive: true});
    }

    this.el.addEventListener('keyup', this.onButtonKeyUp.bind(this));
  }

  onKeyUp(e) {
    const keycode = e.keyCode || e.which;
    if (keycode == 13) {
      this.el.click();
    }
  }

  onButtonKeyUp(e) {
    const target = e.currentTarget;
    const keycode = e.keyCode || e.which;
    if (keycode == 32) {
      target.click();
    }
  }

  onClick() {
    document.documentElement.classList.toggle(this.htmlToggle, this.el.checked);
  }
}

export default Button;


